var _a;
import { EStatus } from "./DownloadCard";
export var dummyDownload = [
    {
        deliveryTime: "Just now",
        text: "Lead Summary",
        statusText: EStatus.COMPLETED,
        showReset: false,
    },
    {
        deliveryTime: "2024-05-20 10:00 AM",
        text: "Revenue Summary",
        statusText: EStatus.PENDING,
        showReset: false,
    },
    {
        deliveryTime: "2024-05-21 12:30 PM",
        text: "Download user data",
        statusText: EStatus.COMPLETED,
        showReset: false,
    },
    {
        deliveryTime: "2024-05-21 12:30 PM",
        text: "Download user data",
        statusText: EStatus.FAILED,
        showReset: true,
    },
    {
        deliveryTime: "2024-05-21 12:30 PM",
        text: "Download user data",
        statusText: EStatus.COMPLETED,
        showReset: false,
    },
];
export var DownloadTimeCategory;
(function (DownloadTimeCategory) {
    DownloadTimeCategory["TODAY"] = "Today";
    DownloadTimeCategory["YESTERDAY"] = "Yesterday";
    DownloadTimeCategory["EARLIER_THIS_WEEK"] = "Earlier this Week";
    DownloadTimeCategory["TWO_WEEKS_AGO"] = "Two weeks ago";
    DownloadTimeCategory["EARLIER_THIS_MONTH"] = "Earlier this month";
    DownloadTimeCategory["OLDER"] = "Older";
})(DownloadTimeCategory || (DownloadTimeCategory = {}));
export var downloadCategory = [
    {
        category: DownloadTimeCategory.TODAY,
    },
    {
        category: DownloadTimeCategory.YESTERDAY,
    },
    {
        category: DownloadTimeCategory.EARLIER_THIS_WEEK,
    },
    {
        category: DownloadTimeCategory.TWO_WEEKS_AGO,
    },
    {
        category: DownloadTimeCategory.EARLIER_THIS_MONTH,
    },
    {
        category: DownloadTimeCategory.OLDER,
    },
];
export var CurrentView = (_a = {},
    _a[DownloadTimeCategory.TODAY] = false,
    _a[DownloadTimeCategory.YESTERDAY] = false,
    _a[DownloadTimeCategory.EARLIER_THIS_WEEK] = false,
    _a[DownloadTimeCategory.TWO_WEEKS_AGO] = false,
    _a[DownloadTimeCategory.EARLIER_THIS_MONTH] = false,
    _a[DownloadTimeCategory.OLDER] = false,
    _a);
